module.exports = __webpack_public_path__ + "static/media/oxygen_sensor.95b10524.svg";